import React from "react";

const ErrorPage: React.FC = () => {
    return (
        <div className="grid h-screen place-content-center bg-white px-4">
            <h1 className="uppercase tracking-widest text-gray-500">404 | Session not found or over</h1>
        </div>
    )
}
export default ErrorPage;